export default "__VITE_ASSET__BMY1$2ch__"